import {Money, NonNegativeInt, createMoney, createMoneyRepresentation, exchange, fromMoney} from '@raison/types';
import {useEffect, useMemo, useState} from 'react';
import {locale} from '~/config';
import {BareAccount} from '../../../../model/Scheme/BareAccount';
import {ExchangeSettings} from '../../../../model/Scheme/ExchangeSettings';
import {renderExchangeDetails} from './usePreview/renderExchangeDetails';

interface UsePreviewProps {
    readonly fromAccount: BareAccount;

    readonly toAccount: BareAccount;

    readonly settings: ExchangeSettings;

    readonly inputMoney: Money;
}

export const usePreview = ({fromAccount, toAccount, settings, inputMoney}: UsePreviewProps) => {
    const rateMoneyRepresentation = createMoneyRepresentation(
        settings.exchangeRate,
        toAccount.currency,
        5 as NonNegativeInt,
        5 as NonNegativeInt,
        locale
    ); // FIXME remove magic number 5

    const [resultMoney, setResultMoney] = useState(createMoney(toAccount.currency, toAccount.decimals));

    useEffect(() => {
        setResultMoney(exchange(inputMoney, toAccount.currency, toAccount.decimals, settings.exchangeRate));
    }, [inputMoney.amount]);

    const resultMoneyRepresentation = useMemo(() => fromMoney(resultMoney, locale), [resultMoney, locale]);

    const renderPreview = () =>
        renderExchangeDetails({baseCurrency: fromAccount.currency, rateMoneyRepresentation, resultMoneyRepresentation});

    return {renderPreview, resultMoney};
};
